import { attr, Model } from 'redux-orm';
import type { PayloadAction } from '@dpdgroupuk/redux-action-creator';

import { ENTITY_NAME } from '../constants';
import { ACTIONS } from './actions';

export class Claim extends Model {
  // eslint-disable-next-line no-use-before-define
  static reducer(action: PayloadAction, Claim: Claim) {
    if (action.type === ACTIONS.FETCH_PARCEL_CLAIMS.SUCCESS) {
      Claim.create({
        ...action.payload,
      });
    }
  }

  static modelName = ENTITY_NAME.CLAIM;

  static fields = {
    parcelCode: attr(),
  };

  static options = {
    idAttribute: 'parcelCode',
  };
}
